var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<gg-tabs active=\"vm.activeTab\" specify-which-tabs-to-render=\"true\" class=\"c-tab c-tab--small c-tab--panel-fill\"><gg-tab name=\"tab-{{$index+1}}\" label=\"{{variation.name}}\" ng-repeat=\"variation in vm.variations\"><div ng-if=\"vm.shouldShowVariation($index)\" class=\"c-panel c-panel--paddless\"><variations-form campaign=\"vm.campaign\" variation=\"variation\" game-campaigns=\"vm.gameCampaigns\" disable-field=\"vm.disableField\"></variations-form></div></gg-tab><gg-tab ng-if=\"!vm.disableField &amp;&amp; vm.currentGame.value.permissions.can_edit\"><gg-tab-heading><a name=\"create_new_segment\" ng-click=\"vm.addNewVariation($event)\" class=\"c-link c-link--primary new-variation\"><span gg-icon=\"icon-plus\"></span>{{ 'new' | translate }}</a></gg-tab-heading></gg-tab></gg-tabs>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/creatives/variationsIndex.jade
 ** module id = 799
 ** module chunks = 0
 **/